(function () {
  if (window.cVSaMix02) return;
  window.cVSaMix02 = true;

  var EVT = 'aftersell-upcart:public-events:';
  var SEL = {
    popup: 'CartPopup',
    body: '.upcart-cart-body',
    items: '.upcart-public-cart-items',
    item: '.upcart-public-cart-item'
  };

  var config = document.getElementById('c-v-sa-mix-02-config');
  var template = document.getElementById('c-v-sa-mix-02-template');
  if (!config || !template) return;

  function num(name) {
    var v = parseInt(config.getAttribute('data-' + name), 10);
    return isNaN(v) ? 0 : v;
  }
  var DEBOUNCE = num('debounce');

  function getPopup() {
    return document.getElementById(SEL.popup);
  }

  var node = null;
  var trackEl = null;
  var cards = [];
  var dots = [];
  var activeIndex = 0;
  var observer = null;
  var placeTimer = null;
  var scrollFrame = null;

  function setActive(index) {
    if (index === activeIndex) return;
    activeIndex = index;
    for (var i = 0; i < dots.length; i++) {
      var on = i === index;
      dots[i].classList.toggle('c-v-sa-mix-02__dot--active', on);
      if (on) dots[i].setAttribute('aria-current', 'true');
      else dots[i].removeAttribute('aria-current');
    }
  }

  function cardScrollLeft(card) {
    return card.offsetLeft - trackEl.offsetLeft - (parseFloat(getComputedStyle(trackEl).paddingLeft) || 0);
  }

  function readActive() {
    scrollFrame = null;
    if (!trackEl || !cards.length) return;
    var x = trackEl.scrollLeft;
    var max = trackEl.scrollWidth - trackEl.clientWidth;
    var best = 0;
    if (max > 0 && x >= max - 2) {
      best = cards.length - 1;
    } else {
      var bestDist = Infinity;
      for (var i = 0; i < cards.length; i++) {
        var d = Math.abs(cardScrollLeft(cards[i]) - x);
        if (d < bestDist) { bestDist = d; best = i; }
      }
    }
    setActive(best);
  }

  // Mouse drag to swipe (desktop). Touch keeps native scrolling. Snap is paused while
  // dragging, then the track settles on the next/previous card in the drag direction.
  function bindDrag() {
    var DRAGGING = 'c-v-sa-mix-02__track--dragging';
    var pointerId = null;
    var startX = 0;
    var startScroll = 0;

    function snapTarget() {
      var x = trackEl.scrollLeft;
      if (x === startScroll) return null;
      var i;
      if (x > startScroll) {
        for (i = 0; i < cards.length; i++) {
          if (cardScrollLeft(cards[i]) > startScroll) return i;
        }
        return cards.length - 1;
      }
      for (i = cards.length - 1; i >= 0; i--) {
        if (cardScrollLeft(cards[i]) < startScroll) return i;
      }
      return 0;
    }

    function end(e) {
      if (pointerId === null || e.pointerId !== pointerId) return;
      pointerId = null;
      var i = snapTarget();
      trackEl.classList.remove(DRAGGING);
      if (i !== null && cards[i]) {
        trackEl.scrollTo({ left: cardScrollLeft(cards[i]), behavior: 'smooth' });
      }
    }

    trackEl.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      pointerId = e.pointerId;
      startX = e.clientX;
      startScroll = trackEl.scrollLeft;
      trackEl.classList.add(DRAGGING);
      if (trackEl.setPointerCapture) trackEl.setPointerCapture(pointerId);
      e.preventDefault();
    });

    trackEl.addEventListener('pointermove', function (e) {
      if (pointerId === null || e.pointerId !== pointerId) return;
      trackEl.scrollLeft = startScroll - (e.clientX - startX);
    });

    trackEl.addEventListener('pointerup', end);
    trackEl.addEventListener('pointercancel', end);
    trackEl.addEventListener('lostpointercapture', end);
  }

  function build() {
    var frag = template.content.cloneNode(true);
    node = frag.querySelector('.c-v-sa-mix-02');
    if (!node) return false;
    trackEl = node.querySelector('.c-v-sa-mix-02__track');
    cards = Array.prototype.slice.call(node.querySelectorAll('.c-v-sa-mix-02__card'));
    dots = Array.prototype.slice.call(node.querySelectorAll('.c-v-sa-mix-02__dot'));
    if (!trackEl) return false;

    trackEl.addEventListener('scroll', function () {
      if (scrollFrame === null) scrollFrame = window.requestAnimationFrame(readActive);
    }, { passive: true });

    bindDrag();

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        if (!cards[i]) return;
        trackEl.scrollTo({ left: cardScrollLeft(cards[i]), behavior: 'smooth' });
      });
    });
    return true;
  }

  // Returns [parent, referenceNode] for insertBefore, or null when the drawer has no
  // usable anchor (closed before first render, empty cart, unknown markup).
  function target() {
    var popup = getPopup();
    if (!popup) return null;
    var body = popup.querySelector(SEL.body);
    if (!body) return null;
    var items = body.querySelector(SEL.items);
    if (!items || items.parentNode !== body || !items.querySelector(SEL.item)) return null;
    return [body, items.nextSibling];
  }

  function place() {
    placeTimer = null;
    var t = target();
    if (!t) {
      if (node && node.parentNode) node.parentNode.removeChild(node);
      return;
    }
    if (!node && !build()) return;
    var parent = t[0];
    var ref = t[1];
    if (ref === node) return; // already right after its anchor
    if (node.parentNode === parent && ref === null && parent.lastChild === node) return;
    parent.insertBefore(node, ref);
    // Moving the node can reset its scroll position; resync the dots.
    readActive();
    watch();
  }

  function schedule() {
    clearTimeout(placeTimer);
    placeTimer = setTimeout(place, DEBOUNCE);
  }

  function watch() {
    if (observer) return;
    var popup = getPopup();
    if (!popup || typeof MutationObserver !== 'function') return;
    observer = new MutationObserver(function (records) {
      // Ignore mutations made inside our own node (scroll state, dot classes).
      for (var i = 0; i < records.length; i++) {
        if (!node || !node.contains(records[i].target)) { schedule(); return; }
      }
    });
    observer.observe(popup, { childList: true, subtree: true });
  }

  ['cart-opened', 'cart-updated', 'cart-loaded', 'upsells:rendered'].forEach(function (name) {
    window.addEventListener(EVT + name, schedule);
  });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule);
  } else {
    schedule();
  }
})();
